<nz-modal
  [nzWrapClassName]="userType === 'expert' ? 'form-modal' : ''"
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30 modal-add-group'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}"
  (nzOnCancel)="onCloseModal(false)">
  <ng-template #modalTitle>
    <div class="container-steps-modal" [@fadeInAnimation] *ngIf="userType === 'expert'">
      <h2 class="text-title-md-bold title-modal">Reprogramar cita</h2>
      <p class="text-info mt-xxs">Se cambiará el horario de la cita</p>
    </div>
    <div class="container-steps-modal" [@fadeInAnimation] *ngIf="userType === 'patient'">
      <h2 class="text-title-md-bold title-modal">Reprogramar cita</h2>
      <p class="text-info mt-xxs">Por favor contacta a la sucursal para realizar cambios en tu cita</p>
    </div>
  </ng-template>

  <ng-template #modalContent>
    <div class="container-modal" [@fadeInAnimation] *ngIf="userType === 'expert'">
      <form #formAppointment="ngForm">
        <div class="container-dates" *ngIf="stepSection>= 1" @fadeInAnimation [class.disabled-container]="stepSection > currentStepSection &&
          currentStepSection <1">
            <div class="title-section-form">
              <p class="title text-subtitle-bold-upper">FECHA DE LA CITA</p>
              <div class="default-dates">
                <app-card-date-appointment *ngFor="let block of itemsCardAppoinment; index as i" [value]="block" [active]="itemDateSelected ===
                  block.id" (click)="onSelectDate(block)"></app-card-date-appointment>
              </div>
              <div nz-row nzGutter="16" class="mt-xxs">
                <div nz-col nzXs="24" nzSm="12" nzLg="6" class="mb-sm" *ngIf="itemDateSelected === 'other'" @fadeInAnimation>
                  <p class="input-label-form">Fecha</p>
                  <nz-date-picker [required]="true" [nzFormat]="this.platformConfig.FORMAT.DATE.DDMMYYYY" [(ngModel)]="initDate" #ngInitDate="ngModel" name="ngInitDate"
                    nzPlaceHolder="Selecciona la fecha" nzAllowClear="false" (ngModelChange)="onSelectCustomDate($event)"
                    [nzDisabledDate]="utilitiesService.disabledPastDate"></nz-date-picker>
                </div>
                <div nz-col nzXs="24" nzSm="12" nzLg="8" class="mb-sm" *ngIf="itemDateSelected === 'other'" @fadeInAnimation>
                  <p class="input-label-form">Zona horaria</p>
                  <nz-select [(ngModel)]="timeZone" nzPlaceHolder="Zona horaria" #ngTimeZone="ngModel" name="ngTimeZone"
                    (ngModelChange)="onSelectTimezone($event)">
                    <nz-option *ngFor="let timeZone of this.timeZones;" [nzLabel]="timeZone" [nzValue]="timeZone"></nz-option>
                  </nz-select>
                </div>
                <div nz-col nzXs="24" nzSm="10" nzLg="10" class="mb-sm" @fadeInAnimation>
                  <p class="input-label-form">Duración</p>
                  <div class="durations">
                    <div *ngFor="let duration of durations" class="duration card-container-grey padding-md border-radius-sm"
                      [class.card-container-active]="duration.value === durationSelected" (click)="onSelectDuration(duration)">
                      <p class="text-subtitle-bold">{{ duration.label }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div nz-row [nzGutter]="16" class="container-branch" *ngIf="stepSection>= 2" @fadeInAnimation [class.disabled-container]="stepSection >
            currentStepSection && currentStepSection <2">
              <div nz-col nzXs="24" nzLg="24" nzXl="24" class="title-section-form">
                <p class="title text-subtitle-bold-upper">DISPONIBILIDAD</p>
                <app-date-component
                  [hideIndicatorToday]="true"
                  [date]="selectedDate"
                  [disabledPastDays]="true"
                  (select)="onSelectDayFromDynamicSchedule()"
                  (filterDay)="onSelectDayFromDynamicSchedule()"
                  class="mb-xxs"></app-date-component>
                <div class="disponibility tw-w-full" nz-row [nzGutter]="[20, 20]">
                  <div nz-col nzXs="12" nzSm="8" nzMd="6" nzLg="4" nzXXl="3" *ngFor="let spot of (scheduleAvailability$ | async)?.spots;
                    index as i">
                    <div class="block block-hour-{{i}} card-container-grey padding-md border-radius-sm" (click)="onSelectHour(spot)"
                      [class.card-container-active]="spotSelected === spot.startSystem" [class.disabled-spot]="!spot.available">
                      <p class="text-subtitle-bold">{{ (spot | getDateFromSystem) | date:'HH:mm a' }}</p>
                    </div>
                  </div>
                  <p *ngIf="(scheduleAvailability$ | async)?.spots?.length === 0" class="text-info ml-xs tw-w-full">No hay horarios disponibles</p>
                </div>
              </div>
              <nz-divider style="height: 20px; top: 15px;" nzType="horizontal"></nz-divider>
              <div nz-col nzXs="24" class="title-section-form">
                <p class="title text-subtitle-bold-upper">REPROGRAMAR</p>

                <p>Cita {{ (appointment$ | async)?.type | getTypeAppointment }}</p>

                <p *ngIf="hourSelected" class="text-regular-black" style="margin-top: 5px;">Para <span style="text-decoration: underline;">{{
                    (!isToday ? ' el ' +
                    (this.selectedDate | date:'fullDate') : 'Hoy') }} de {{ hourSelected | date:'h:mm a' }} - {{ hourSelectedEnd | date:'h:mm a' }}
                  </span></p> <!-- viernes 15 de Julio de 09:00 AM a 10:00 AM -->

                <span *ngIf="(appointment$ | async)?.type && (appointment$ | async)?.type !== appointmentTypeEnum?.ON_SITE && (appointment$ |
                  async)?.meetUrl" class="text-regular-black">URL reunión: <a [href]="(appointment$ | async)?.meetUrl" target="_blank">{{
                    (appointment$ | async)?.meetUrl }}</a></span>
              </div>
            </div>
          </form>
          <nz-divider></nz-divider>
        </div>
        <div class="container-footer-modal" *ngIf="userType === 'patient' && branchEmail">
          <div nz-row [nzGutter]="[16, 16]"  >
            <div nz-col [nzXs]="'24'">
              <p class="text-title mb-xs">Correo electrónico de la sucursal</p>
              <p nz-typography nzCopyable [nzCopyTooltips]="['copiar', 'copiado']" [nzCopyText]="branchEmail" class="d-flex text-info mb-xs">{{ branchEmail }}</p>
            </div>
            <div nz-col [nzXs]="'24'">
              <div nz-row [nzGutter]="[16, 16]">
                <div nz-col [nzXs]="'24'" [nzMd]="'12'">
                  <p class="text-title  mb-xs">Teléfono(s) de la sucursal</p>
                  <ng-container *ngFor="let branchPhone of branchPhones">
                    <div class="d-flex align-items-center">
                      <p nz-typography nzCopyable [nzCopyTooltips]="['copiar', 'copiado']" [nzCopyText]="branchPhone.areaCode + branchPhone.phoneNumber"
                         class=" d-flex text-info mb-xxs">
                        {{ '(' + branchPhone.areaCode + ') ' + branchPhone.phoneNumber }}
                      </p>
                      <span class="text-info-sm ml-xxs" *ngIf="branchPhone.ext">extensión: {{ branchPhone.ext }}</span>
                    </div>
                  </ng-container>
                </div>
                <div nz-col [nzXs]="'24'" [nzMd]="'12'" *ngIf="clinicPhones.length > 0">
                  <p class="text-title  mb-xs">Teléfono(s) de la clínica</p>
                  <ng-container *ngFor="let clinicPhone of clinicPhones">
                    <div class="d-flex align-items-center">
                      <p nz-typography nzCopyable [nzCopyTooltips]="['copiar', 'copiado']" [nzCopyText]="clinicPhone.areaCode + clinicPhone.phoneNumber"
                         class="d-flex text-info mb-xxs">
                        {{ '(' + clinicPhone.areaCode + ') ' + clinicPhone.phoneNumber }}
                      </p>
                      <span class="text-info-sm ml-xxs" *ngIf="clinicPhone.ext">extensión: {{ clinicPhone.ext }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <!--<p class="text-title mb-xs">Correo electrónico de la sucursal</p>
          <p nz-typography nzCopyable [nzCopyTooltips]="['copiar', 'copiado']" [nzCopyText]="branchEmail" class="text-info mb-xs">{{ branchEmail }}</p>
          <div nz-row [nzGutter]="[30, 30]">
            <div nz-col nzXs="24" nzMd="12" nzLg="12">
              <p class="text-title mt-md mb-xs">Teléfono(s) de la sucursal</p>
              <ng-container *ngFor="let branchPhone of branchPhones">
                <div class="d-flex align-items-center">
                  <p nz-typography nzCopyable [nzCopyTooltips]="['copiar', 'copiado']" [nzCopyText]="branchPhone.areaCode + branchPhone.phoneNumber"
                    class="text-info mb-xxs">
                    {{ '(' + branchPhone.areaCode + ') ' + branchPhone.phoneNumber }}
                  </p>
                  <span class="text-info-sm ml-xxs" *ngIf="branchPhone.ext">extensión: {{ branchPhone.ext }}</span>
                </div>
              </ng-container>
            </div>
            <div nz-col nzXs="24" nzMd="12" nzLg="12">
              <p class="text-title mt-md mb-xs">Teléfono(s) de la clínica</p>
              <ng-container *ngFor="let clinicPhone of clinicPhones">
                <div class="d-flex align-items-center">
                  <p nz-typography nzCopyable [nzCopyTooltips]="['copiar', 'copiado']" [nzCopyText]="clinicPhone.areaCode + clinicPhone.phoneNumber"
                    class="text-info mb-xxs">
                    {{ '(' + clinicPhone.areaCode + ') ' + clinicPhone.phoneNumber }}
                  </p>
                  <span class="text-info-sm ml-xxs" *ngIf="clinicPhone.ext">extensión: {{ clinicPhone.ext }}</span>
                </div>
              </ng-container>
            </div>
          </div>-->
        </div>
        <!--Cuando es una cita virtual, no se traen datos de la cliinica-->
        <div class="container-footer-modal" *ngIf="userType === 'patient' && !branchEmail && clinicPhones.length > 0">
          <div  class="tw-w-full" nz-row [nzGutter]="[16, 16]">
            <div nz-col [nzXs]="'24'" >
              <p class="text-title  mb-xs">Teléfono(s) de la clínica</p>
              <ng-container *ngFor="let clinicPhone of clinicPhones">
                <div class="d-flex align-items-center">
                  <p nz-typography nzCopyable [nzCopyTooltips]="['copiar', 'copiado']" [nzCopyText]="clinicPhone.areaCode + clinicPhone.phoneNumber"
                     class="d-flex text-info mb-xxs">
                    {{ '(' + clinicPhone.areaCode + ') ' + clinicPhone.phoneNumber }}
                  </p>
                  <span class="text-info-sm ml-xxs" *ngIf="clinicPhone.ext">extensión: {{ clinicPhone.ext }}</span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #modalFooter>
        <div class="container-footer-modal" [@fadeInAnimation] *ngIf="userType === 'expert'">
          <button
            class="mr-xxs"
            (click)="onCloseModal(false)"
            nz-button nzType="cancel">
            <i nz-icon nzType="close-circle" nzTheme="outline"></i>
            CANCELAR</button>
          <button
            (click)="onCloseModal(true)"
            [disabled]="stepSection <3 || currentStepSection <3"
            nz-button nzType="primary">
            <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
            REPROGRAMAR CITA</button>
        </div>
        <div class="container-footer-modal" [@fadeInAnimation] *ngIf="userType === 'patient'">
          <button
            (click)="onCloseModal(true)"
            nz-button nzType="primary">CERRAR
          </button>
        </div>
      </ng-template>
    </nz-modal>
